var map = {
	"./s_0.png": 33726,
	"./s_1.png": 21415,
	"./s_10.png": 12711,
	"./s_11.png": 20574,
	"./s_2.png": 52940,
	"./s_3.png": 35829,
	"./s_4.png": 61530,
	"./s_5.png": 83107,
	"./s_6.png": 29896,
	"./s_7.png": 86193,
	"./s_8.png": 58358,
	"./s_9.png": 36447,
	"./s_9_1.png": 73427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16139;